export interface IAPIWiringInstructionsResponse {
  account_number: string;
  routing_number: string;
  obi: string;
}

export interface IAPIWiringInstructionsData {
  accountNumber: string;
  routingNumber: string;
  obi: string;
}

export const convertIAPIWiringInstructionsResponseToIAPIWiringInstructionsData = ({
  account_number,
  routing_number,
  obi,
}: IAPIWiringInstructionsResponse): IAPIWiringInstructionsData => ({
  accountNumber: account_number,
  routingNumber: routing_number,
  obi,
});

export const convertIAPIWiringInstructionsDataToIAPIWiringInstructionsResponse = ({
  accountNumber,
  routingNumber,
  obi,
}: IAPIWiringInstructionsData): IAPIWiringInstructionsResponse => ({
  account_number: accountNumber,
  routing_number: routingNumber,
  obi,
});
